<template>
  <div>
    <h3 class="my-1">Résultats par boucle</h3>
    <v-row no-gutters v-if="$store.state.loading">
      <v-col class="pa-1"> <v-skeleton-loader class="gradient" type="list-item" height="36"></v-skeleton-loader>
      </v-col></v-row>
    <v-row no-gutters v-else>
      <v-col cols="12" md="4" class="pa-1" v-for="i in nb_list_with_results" :key="i">
        <v-btn block color="grey-lighten-2"
          :class="[$store.state.selected_boucle == i ? 'gradient text-secondary' : '']" @click="onSelectLoop(i)">{{ i
          }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    nb_list_with_results() {
      return this.loop_list_with_results.length;
    },
    loop_list_with_results() {
      return this.$store.getters.getLoopListWithResults;
    },
  },
  methods: {
    onSelectLoop(id) {
      this.$store.commit("setSelectedLoop", id);
      this.$router.push({ name: "BoucleView", params: { challenge_uuid: this.$store.state.selected_challenge, id: id } });
    },
  },
};
</script>

<style lang="scss" scoped></style>